import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Assessment from "@/pages/Assessment";
import Report from "@/pages/Report";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App min-h-screen bg-navy-900 text-ink">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/report/:id" element={<Report />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#1E293B", border: "1px solid rgba(212,175,55,0.3)", color: "#F8FAFC" } }} />
    </div>
  );
}

export default App;
